import Button from '../../../components/Button';
import { pageShell } from '../../../styles/pageShell';
import { aiChatShell } from '../../../styles/aiChatShell';

/**
 * チャットヘッダーコンポーネント
 */
export default function ChatHeader({ parametersText, onNewConversation }) {
    return (
        <div className={`${pageShell.header} flex-wrap`}>
            <div className={aiChatShell.headerMain}>
                <h2 className={pageShell.title}>Hummingloom</h2>
                {parametersText && (
                    <div className={aiChatShell.parameters}>
                        {parametersText}
                    </div>
                )}
            </div>
            <div className={`${pageShell.headerAside} ${aiChatShell.actions}`}>
                <Button
                    type="button"
                    variant="primary"
                    size="lg"
                    onClick={onNewConversation}
                >
                    <span className="material-icons" aria-hidden="true">edit_square</span>
                    新しいチャット
                </Button>
            </div>
        </div>
    );
}
